import React, { useState, useEffect,useContext } from 'react';
import '../styles/filing.css'
import { Link, useNavigate,useParams  } from 'react-router-dom';
import DynamicIcon from '../components/dynamicicon';
import Case_Search from '../components/core/case_search';

import JisButton from '../components/controls/jisButton';
import FlowItem from '../components/controls/flowitem';
import { ShareContext } from '../context/ShareContext';

import * as Constants from '../constants';
import JisDialog from '../components/dialog';
import Gazette from '../components/core/gazette';
import BackLoader from '../components/backloader';
import Payment from '../components/core/payment';
import JisYesNo from '../components/controls/jisYesNo';

function FilingMotion() {
  const FeeTYPEID=31;
   const navigate = useNavigate()
     const { caseid } = useParams();
     
      const {  activePage, token, profile,frequentData, setIsExpired} = useContext(ShareContext);
      const [cinfo, setCase] =useState(null);
      const [flow, setFlow] = useState({pos:1, code:"motion_details"});
      const [flowerror, setFlowError]=useState('');
       const [casefeeId, setcasefeeId] = useState(null)
       const [parties, setParties]= useState([]);
       const [isSuccess, setIsSuccess]= useState(false);
       const [loading, setLoading] = useState(false);
       const [count,setCount]=useState(0);
       const [isLoaded, setIsLoaded]= useState(false);
       const [motionids, setmotionIds] = useState(''); // this is to store all motions id from this flow
   const [motions,setMotions] = useState([]);
       const [motion, setMotion] =useState([]);
       const [motionPrayers, setPrayers] = useState([{prayer:''}]);
         const [removingIndex, setRemovingIndex] = useState(null);
         const [isNonService, setIsNonService] = useState(false);
         const [isService, setIsService] = useState(false);
         const [isRelist, setIsRelist] = useState(false);
         const [isSetAside,setIsSetAside]= useState(false);


    const onGazetteProceed=(e)=>{
           console.log('after processing... here is value')
           console.log(e);
           setcasefeeId(e.feeid);
           setIsSuccess(e.isPaid);
           if(!e.isPaid){
              on_gazette();
           }
           
       }
           const on_gazette=()=>{
           setFlow({pos:3,code:"payment"});
       } 
          const on_payment_back=()=> setFlow({pos:2,code:"gazette"});
      
         useEffect(() => {
           if(caseid!=null){
              onLoad(caseid);
              onLoadServiceStatus(caseid); // for the service
           }
                     
         }, [caseid]);
   const onLoad= async(_caseid)=>{
               //for account registration
           try {
   
               setLoading(true);
               const resp = await fetch(`${Constants.apiUrl}/filing/mini-case-details/${_caseid}`, { 
                   method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
               const data = await resp.json();
               setLoading(false);
               if(data.code==0){
                   //ready
                   // fee, feelines, cinfo , parties 
                 setCase(data.caseinfo)

                   setParties(data.parties.filter(c=>c.legalCounselId==profile.id));
                   setIsLoaded(true);
               } else if(data.code==-10){
                      setIsExpired(true);
                  }
               
               } catch (error) {
               setLoading(false);
               console.error(error);   
               }
           }
    const onLoadServiceStatus= async(_caseid)=>{
               //for account registration
           try {
   
               setLoading(true);
               const resp = await fetch(`${Constants.apiUrl}/filing/case-services-status/${_caseid}`, { 
                   method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
               const data = await resp.json();
               setLoading(false);
               if(data.code==0){
                setIsNonService(data.isNonService);
                setIsService(data.isService);
                setIsRelist(data.isRelist);
                setIsSetAside(data.isSetAside)
               } else if(data.code==-10){
                      setIsExpired(true);
                  }
               
               } catch (error) {
               setLoading(false);
               console.error(error);   
               }
           }       
const onSaveMotion=(e)=>{
    e.preventDefault();
   // setParties({...parties,party});
    setMotions(prev => [...prev, {...motion,motionPrayers}]);
    setMotion({partyId:'',motionClassificationId:'',motionTypeId:''});
    setPrayers([{prayer:''}])
}

const onChangePrayer = (index, key, value) => {
  setPrayers(prev =>
    prev.map((item, i) => i === index ? { ...item, [key]: value } : item)
  );
};

const onRemovePrayer = async(index) => {
    if(motionPrayers.length==1){
        return;
    }
  const h=motionPrayers[index];
        if(h && h.id>0){
            await onRemovePrayer_Server(h.id);
        }
     setRemovingIndex(index);
  setTimeout(() => {
    setPrayers(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration

 
};
  const onRemovePrayer_Server= async(id)=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/remove-prayer/${id}`, { 
          method: 'POST',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
       setLoading(false);
        if(data.code==0){
            //caseinfo,parties, claims, causes
           console.log(data);
        } else if(data.code==-10){
                      setIsExpired(true);
                  }

      } catch (error) {
        setLoading(false);
        console.error(error);   
      }
}

const onAddPrayer = () => {
  setPrayers(prev => [...prev, { prayer: '' }]);
};

const onMotionChange = (e) => {
    setMotion({...motion, [e.target.name]: e.target.value})    
}

 const onRemoveMotion_Server= async(id)=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/remove-motion/${id}`, { 
          method: 'POST',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
       setLoading(false);
        if(data.code==0){
            //caseinfo,parties, claims, causes
           console.log(data);
        } else if(data.code==-10){
                      setIsExpired(true);
                  }

      } catch (error) {
        setLoading(false);
        console.error(error);   
      }
}
const onRemoveMotion = async(index) => {
   
    const h=motionPrayers[index];
        if(h && h.id>0){
            await onRemoveMotion_Server(h.id);
        }
     setRemovingIndex(index);
  setTimeout(() => {
    setMotions(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration

 
};

const onEditMotion=(row,index) =>{
    setRemovingIndex(index);
  setTimeout(() => {
    setMotions(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration

  //remove that one and allow it to be edited
      setMotion(row);
      setPrayers(row.motionPrayers);
  }
 const on_motions=async ()=>{

    if( motions.length==0){
        setFlowError("Please file a motion or uncheck the question at the top.")
        return;
    } 
    setLoading(true);
                
        try {
  
          const resp = await fetch(`${Constants.apiUrl}/filing/Motion/${caseid}`, {
            method: 'POST',
              body:JSON.stringify(motions) ,
            headers: {
              'Content-Type': 'application/json, text/plain',
              'Authorization': `Bearer ${token}`,
            },
          });
          
          const data = await resp.json();
          setLoading(false);
          console.log(data);
          if (data.code === 0) {
              //setGazettes(data.gazettes);
              setmotionIds(data.motionids);
               setFlow({pos:2,code:"gazette"});
          }else {   
            
          }
        } catch (error) {
          setLoading(false);
          console.error(error);
          // setErr(Constants.serverErr);
          // onMove();
        }
    
  }
 const onGotoDetails = () =>{
    setIsSuccess(false);
    navigate(`/document-upload/${casefeeId}`); //navigate to login

}
  return (
    <div>

      <div style={{textAlign:'center'}}><h2>{cinfo?.caseTitle?.toUpperCase()}</h2>
        <h3>{cinfo?.caseNumber}</h3>
        </div>
        <div className='multiform'>
          <div  className='flow'>
            <div className='itemgroup'>
                <FlowItem flow={flow} pos={1} code="motion_details" title="Motion Details" />
                <FlowItem flow={flow} pos={2} code="gazette" title="Gazette" />
                <FlowItem flow={flow} pos={3} code="payment" title="Payment" isLast={true} />
            </div>
          </div>
        {flow.code=='motion_details' &&   <div  className='view'>
<div className='view'>
      <div>
        <form onSubmit={onSaveMotion}>
            <div>
                <div className="select-group" style={{width:'50%'}}>
                            <label>Select Party </label>
                                    <select name="partyId" value={motion.partyId} required onChange={onMotionChange} >
                                        <option value="">Select </option>
                                        {parties
                                            //?.filter(opt => opt.partyTypeId == Constants.ClaimantType)
                                            .map((opt, index) => (
                                               <option key={index} value={opt.id}>
                                                {opt.firstName} {opt.lastName??''}
                                                </option>
                                            ))}
                                                                                                
                                            
                                            </select>
                            </div>
                <div style={{display:'flex'}}>
                    <div className="select-group">
                            <label> Motion/Application classification </label>
                                    <select name="motionClassificationId" value={motion.motionClassificationId} required onChange={onMotionChange} >
                                        <option value="">Select </option>
                                        {frequentData?.motionclass?.map((opt) => (
                                        <option key={opt.id} value={opt.id}>
                                            {opt.title}
                                        </option>
                                        ))}
                                    </select>
                            </div>
                    <div className="select-group">
                            <label> Motion/Application Type  </label>
                                    <select name="motionTypeId" value={motion.motionTypeId} required  onChange={onMotionChange} >
                                        <option value="">Select </option>
                                        {frequentData?.motiontypes?.filter((e)=>e.filingTypeId==cinfo?.caseFilingId).map((opt) => (
                                       ((opt.id==14 && isNonService ) 
                                       || (opt.id==15 && isService)
                                       || (opt.id==17 && isRelist)
                                       || (opt.id==18 && isSetAside)
                                      || (opt.id!=14 && opt.id!=15 && opt.id!=17 && opt.id!=18)) && 
                                       <option key={opt.id} value={opt.id}>
                                            {opt.title}
                                        </option>
                                        ))}
                                    </select>
                            </div>        
                </div>
                <div>
                    {motionPrayers?.map((pray, index) => (
                <div key={index} className={`claim-item ${removingIndex === index ? 'removing' : ''}`} style={{display:'flex' ,alignItems:'center'}}>
                    <div style={{ flex: 1, }}>
                    
                    <div  className="input-group">
                            <label>Particulars of Prayers Sought <span className="required">*</span> </label>
                            <div className='input-wrapper'>
                                <textarea placeholder=' Particulars of Prayers Sought' required={true}  value={pray.prayer}
                        onChange={(e) => onChangePrayer(index, 'prayer', e.target.value)}   />
                            </div>
                        </div>
    
                    </div>
                    <div className='delete' onClick={() => onRemovePrayer(index)} style={{color:'red', display:'flex', flexDirection:'column', alignItems:'center'}}>
                    <DynamicIcon iname="trash-2" /> <span style={{fontSize:12}}>Delete</span>
                    </div>
                </div>
            ))}
                <JisButton icon="add" variant='outline' onClick={onAddPrayer}>Add Prayer</JisButton>

                    </div>

                    <div style={{marginTop:16}}>
                        <JisButton icon="add" type='submit'>Save Motion</JisButton>
                    </div>
            </div>
        </form>
            
                {motions.length> 0 && 
                <div className='table-div'>
                    <table>
                    <tr>
                        <th>Party</th>
                        <th>Application Classification</th>
                        <th>Application Type</th>
                        <th>Prayers</th>
                        <th>Action</th>
                    </tr>
                    {motions?.map((opt,index) => (
                        <tr key={index}>
                            <td>{Constants.getItemById(parties,opt.partyId)?.firstName} {Constants.getItemById(parties,opt.partyId)?.lastName??''}</td>
                            <td>{Constants.getItemById(frequentData.motionclass,opt.motionClassificationId)?.title}</td>
                            <td>{ Constants.getItemById(frequentData.motiontypes,opt.motionTypeId)?.title}</td>
                            <td>
                                <ol>
                                    {opt.motionPrayers?.map((pray,ind) => (
                                        <li key={ind}>{ind+1}. {pray.prayer}</li>
                                    ))}
                                </ol>
                            </td>
                        
                            <td><div className='groupbtn'> <JisButton variant='plain' icon="edit" onClick={()=>onEditMotion(opt,index)}>Edit</JisButton> 
                            <JisButton variant='plain' icon="x" onClick={()=>onRemoveMotion(index)}>Remove</JisButton></div></td>
                        </tr>
                                        
                       ))}
                    </table>   
                    </div>}  
        </div>
        
<div className='flowerror'>{flowerror}</div>
         <div className='flowbuttongroup'>
                        
                        <JisButton type='submit' onClick={on_motions}>Proceed</JisButton>
                    </div>
        </div>
          </div>}
           {flow.code=='gazette' &&  <div className='view'>
        <Gazette filingtypeid={cinfo?.caseFilingId} levelid={cinfo?.caseCategoryId}   feetypeid={FeeTYPEID}
        token={token} onProceed={(e)=>onGazetteProceed(e)} caseid={cinfo?.caseId} feeId={casefeeId}  
        fillingsource="motion" sourceid={motionids}>
             <div className="top-nav">
                <div className="left-top">
                    <div className="top">
                        <h2>{cinfo?.referenceNumber} | {Constants.getItemById(frequentData.casecategories,cinfo?.caseCategoryId)?.categoryTitle}</h2>
                        
                    </div>
                    <p>Select items related to the motion that you are filing</p>
                </div>
                <p className="nav-status">Motion Filing /Specifications</p>
            </div>

        </Gazette>


        </div>} 
      {flow.code=='payment' && <div className='view'>

        <Payment feeid={casefeeId} token={token} />
        
         <div className='flowbuttongroup'>
                        <JisButton onClick={on_payment_back}>Back</JisButton>
                       
                    </div>
        </div>} 
        </div>
       <BackLoader open={loading} />  
        {isSuccess && <JisDialog title="Case Created Successfully.">
               <div>This case is created successfully.  Payment is not required. Please continue to upload document</div>
                   <JisButton onClick={onGotoDetails} >Upload document</JisButton>
             </JisDialog>} 
    </div>
  );
}

export default FilingMotion;